/**
 * Converts an array of MIME types to a comma separated string for display.
 * @param {Array} types List of MIME types
 * @return {string}
 */
const getLabelFromMimeTypes = (types: string[] = []): string => {
    const labels = types
        .map(type => {
            switch (type) {
                case 'video/mp4':
                    return 'MP4'
                case 'video/quicktime':
                    return 'MOV'
                case 'video/m4v':
                    return 'M4V'
                case 'video/mpeg':
                    return 'MPEG'
                case 'image/png':
                    return 'PNG'
                case 'image/gif':
                    return 'GIF'
                case 'image/jpeg':
                    return 'JPG'
                case 'font/ttf':
                    return 'TTF'
                default:
                    return ''
            }
        })
        .filter(value => !!value)

    return labels
        .map((type, i) => {
            if (labels.length > 1 && i === labels.length - 1) {
                return `or ${type}`
            } else {
                return `${type}${labels.length > 2 ? ',' : ''}`
            }
        })
        .join(' ')
}

export default getLabelFromMimeTypes
